"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm$loggedInAdmin$rol;
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "app-container"
  }, [_vm.dispatchInfo ? _c("el-descriptions", {
    attrs: {
      border: "",
      size: "mini",
      column: 3
    }
  }, [_c("el-descriptions-item", [_c("template", {
    slot: "label"
  }, [_c("i", {
    staticClass: "el-icon-s-order"
  }), _vm._v(" ID ")]), _vm._v(" " + _vm._s(_vm.dispatchInfo.id) + " ")], 2), _vm.dispatchInfo.invoiceNumber ? [_c("el-descriptions-item", [_c("template", {
    slot: "label"
  }, [_c("i", {
    staticClass: "el-icon-document"
  }), _vm._v(" Invoice Number ")]), _vm._v(" " + _vm._s(_vm.dispatchInfo.invoiceNumber) + " ")], 2)] : [_c("el-descriptions-item", [_c("template", {
    slot: "label"
  }, [_c("i", {
    staticClass: "el-icon-document"
  }), _vm._v(" Lots Number ")]), _vm._v(" " + _vm._s(_vm.dispatchInfo.entryNumber) + " ")], 2)], _c("el-descriptions-item", [_c("template", {
    slot: "label"
  }, [_c("i", {
    staticClass: "el-icon-flag"
  }), _vm._v(" Status ")]), _c("el-tag", {
    attrs: {
      type: _vm.dispatchInfo.status === "Pending" ? "warning" : "success",
      size: "mini"
    }
  }, [_vm._v(" " + _vm._s(_vm.dispatchInfo.status) + " ")])], 2), _c("el-descriptions-item", [_c("template", {
    slot: "label"
  }, [_c("i", {
    staticClass: "el-icon-user"
  }), _vm._v(" Dealer ")]), _vm._v(" " + _vm._s(_vm.dispatchInfo.dealer.name) + " "), _vm.dispatchInfo.dealer.code ? _c("span", [_vm._v(" (" + _vm._s(_vm.dispatchInfo.dealer.code) + ") ")]) : _vm._e()], 2), _c("el-descriptions-item", [_c("template", {
    slot: "label"
  }, [_c("i", {
    staticClass: "el-icon-truck"
  }), _vm._v(" Terms of Delivery ")]), _vm.dispatchInfo.editingTermsOfDelivery || _vm.dispatchInfo.id ? [_c("el-input", {
    staticClass: "input-with-select",
    attrs: {
      placeholder: "Please Enter",
      type: "textarea",
      autocomplete: "off",
      rows: 3,
      size: "mini"
    },
    model: {
      value: _vm.dispatchInfo.modifiedTermsOfDelivery,
      callback: function ($$v) {
        _vm.$set(_vm.dispatchInfo, "modifiedTermsOfDelivery", $$v);
      },
      expression: "dispatchInfo.modifiedTermsOfDelivery"
    }
  }, [_c("el-button", {
    attrs: {
      slot: "prepend",
      size: "mini",
      icon: "el-icon-close"
    },
    on: {
      click: function ($event) {
        _vm.dispatchInfo.editingTermsOfDelivery = false;
        _vm.dispatchInfo.modifiedTermsOfDelivery = _vm.dispatchInfo.termsOfDelivery;
      }
    },
    slot: "prepend"
  }), _c("el-button", {
    attrs: {
      slot: "append",
      size: "mini",
      icon: "el-icon-check"
    },
    on: {
      click: _vm.saveTermsOfDelivery
    },
    slot: "append"
  })], 1)] : [_vm._v(" " + _vm._s(_vm.dispatchInfo.termsOfDelivery) + "  "), _c("el-link", {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: [_vm.SUPER_ADMIN],
      expression: "[SUPER_ADMIN]"
    }],
    attrs: {
      icon: "el-icon-edit"
    },
    on: {
      click: function ($event) {
        _vm.dispatchInfo.editingTermsOfDelivery = true;
      }
    }
  })]], 2), _c("el-descriptions-item", [_c("template", {
    slot: "label"
  }, [_c("i", {
    staticClass: "el-icon-label"
  }), _vm._v(" Private Marka ")]), _vm._v(" " + _vm._s(_vm.dispatchInfo.privateMarka) + " ")], 2), _c("el-descriptions-item", [_c("template", {
    slot: "label"
  }, [_c("i", {
    staticClass: "el-icon-ship"
  }), _vm._v(" Transporter ")]), _vm.dispatchInfo.dealersTransporter ? _c("div", [_vm._v(" " + _vm._s(_vm.dispatchInfo.dealersTransporter.transporter.name) + " ")]) : _c("div", [_vm._v(" NA ")])], 2), _c("el-descriptions-item", [_c("template", {
    slot: "label"
  }, [_c("i", {
    staticClass: "el-icon-truck"
  }), _vm._v(" Vehicle Number ")]), _vm.dispatchInfo.editingVehicleNumber ? [_c("el-input", {
    staticClass: "input-with-select",
    attrs: {
      placeholder: "Please Enter",
      autocomplete: "off",
      size: "mini"
    },
    model: {
      value: _vm.dispatchInfo.modifiedVehicleNumber,
      callback: function ($$v) {
        _vm.$set(_vm.dispatchInfo, "modifiedVehicleNumber", $$v);
      },
      expression: "dispatchInfo.modifiedVehicleNumber"
    }
  }, [_c("el-button", {
    attrs: {
      slot: "prepend",
      size: "mini",
      icon: "el-icon-close"
    },
    on: {
      click: function ($event) {
        _vm.dispatchInfo.editingVehicleNumber = false;
        _vm.dispatchInfo.modifiedVehicleNumber = _vm.dispatchInfo.vehicleNumber;
      }
    },
    slot: "prepend"
  }), _c("el-button", {
    attrs: {
      slot: "append",
      size: "mini",
      icon: "el-icon-check"
    },
    on: {
      click: _vm.saveVehicleNumber
    },
    slot: "append"
  })], 1)] : [_vm._v(" " + _vm._s(_vm.dispatchInfo.vehicleNumber || "NA") + "  "), _vm.dispatchInfo.status === "Approved" ? _c("el-link", {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: [_vm.SUPER_ADMIN, _vm.UNIT_MANAGER],
      expression: "[SUPER_ADMIN, UNIT_MANAGER]"
    }],
    attrs: {
      icon: "el-icon-edit"
    },
    on: {
      click: function ($event) {
        _vm.dispatchInfo.editingVehicleNumber = true;
        _vm.dispatchInfo.modifiedVehicleNumber = _vm.dispatchInfo.vehicleNumber;
      }
    }
  }) : _vm._e()]], 2), _c("el-descriptions-item", [_c("template", {
    slot: "label"
  }, [_c("i", {
    staticClass: "el-icon-user"
  }), _vm._v(" Unit Manager ")]), _vm.dispatchInfo.admin ? _c("div", [_vm._v(" " + _vm._s(_vm.dispatchInfo.admin.fullName) + " ")]) : _c("div", [_vm._v(" NA ")])], 2), _c("el-descriptions-item", [_c("template", {
    slot: "label"
  }, [_c("i", {
    staticClass: "el-icon-office-building"
  }), _vm._v(" Unit ")]), _vm.dispatchInfo.unit ? _c("div", [_vm._v(" " + _vm._s(_vm.dispatchInfo.unit.name) + " ")]) : _c("div", [_vm._v(" NA ")])], 2), _c("el-descriptions-item", [_c("template", {
    slot: "label"
  }, [_c("i", {
    staticClass: "el-icon-box"
  }), _vm._v(" Total Carton(s) ")]), _vm._v(" " + _vm._s(_vm.dispatchInfo.totalCartonCount) + " ")], 2), _c("el-descriptions-item", [_c("template", {
    slot: "label"
  }, [_c("i", {
    staticClass: "el-icon-paperclip"
  }), _vm._v(" E-way No ")]), _vm.dispatchInfo.ewayBillNo ? _c("div", [_vm._v(" " + _vm._s(_vm.dispatchInfo.ewayBillNo) + " "), _c("el-link", {
    attrs: {
      type: "primary",
      icon: "el-icon-link",
      target: "_blank",
      href: "https://" + _vm.dispatchInfo.ewayBillUrl
    }
  })], 1) : _c("div", [_vm._v(" - ")])], 2), _c("el-descriptions-item", [_c("template", {
    slot: "label"
  }, [_c("i", {
    staticClass: "el-icon-receipt"
  }), _vm._v(" E-Invoice ACK No ")]), _vm.dispatchInfo.irn ? _c("div", [_vm._v(" " + _vm._s(_vm.dispatchInfo.ackNumber) + " "), _c("el-link", {
    attrs: {
      type: "primary",
      icon: "el-icon-link",
      target: "_blank",
      href: _vm.dispatchInfo.eInvoiceUrl
    }
  })], 1) : _c("div", [_vm._v(" - ")])], 2), _c("el-descriptions-item", [_c("template", {
    slot: "label"
  }, [_c("i", {
    staticClass: "el-icon-timer"
  }), _vm._v(" Created Timestamp ")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.dispatchInfo.createdTimestamp, "DD-MM-YYYY hh:mm a")) + " ")], 2), _c("el-descriptions-item", [_c("template", {
    slot: "label"
  }, [_c("i", {
    staticClass: "el-icon-files"
  }), _vm._v(" fromTally ")]), _vm._v(" " + _vm._s(_vm.dispatchInfo.fromTally ? "Yes" : "No") + " ")], 2), _vm.dispatchInfo.fromTally ? _c("el-descriptions-item", [_c("template", {
    slot: "label"
  }, [_c("i", {
    staticClass: "el-icon-postcard"
  }), _vm._v(" Dispatch Date ")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.dispatchInfo.dispatchDate, "DD-MM-YYYY")) + " ")], 2) : _c("el-descriptions-item", [_c("template", {
    slot: "label"
  }, [_c("i", {
    staticClass: "el-icon-time"
  }), _vm._v(" Approved Timestamp ")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.dispatchInfo.approvedTimestamp, "DD-MM-YYYY hh:mm a")) + " ")], 2)], 2) : _vm._e(), _c("el-divider"), _c("div", {
    staticStyle: {
      "margin-bottom": "15px",
      "text-align": "left"
    }
  }, [_vm.dispatchInfo && _vm.dispatchInfo.status === "Approved" && _vm._isSuperAdmin() ? [_c("el-button", {
    attrs: {
      size: "mini",
      type: "primary",
      icon: "el-icon-edit"
    },
    on: {
      click: _vm.handleEdit
    }
  }, [_vm._v(" Edit ")])] : _vm._e()], 2), _c("el-dialog", {
    attrs: {
      title: "Edit Dispatch",
      visible: _vm.editDialogVisible,
      width: "60%",
      "before-close": _vm.handleEditDialogClose
    },
    on: {
      "update:visible": function ($event) {
        _vm.editDialogVisible = $event;
      }
    }
  }, [_c("el-form", {
    attrs: {
      model: _vm.editForm,
      "label-width": "160px",
      "label-position": "left"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Dealer Transporter"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: "Select Transporter",
      filterable: ""
    },
    model: {
      value: _vm.editForm.dealersTransporterId,
      callback: function ($$v) {
        _vm.$set(_vm.editForm, "dealersTransporterId", $$v);
      },
      expression: "editForm.dealersTransporterId"
    }
  }, _vm._l(_vm.transporterOptions, function (transporter) {
    return _c("el-option", {
      key: transporter.id,
      attrs: {
        label: transporter.name,
        value: transporter.id
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "Eway Bill Number"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Enter Eway Bill Number",
      clearable: ""
    },
    model: {
      value: _vm.editForm.ewayBillNo,
      callback: function ($$v) {
        _vm.$set(_vm.editForm, "ewayBillNo", $$v);
      },
      expression: "editForm.ewayBillNo"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Dealer Special Discount"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Enter Dealer Special Discount",
      clearable: ""
    },
    model: {
      value: _vm.editForm.dealerSpecialDiscount,
      callback: function ($$v) {
        _vm.$set(_vm.editForm, "dealerSpecialDiscount", $$v);
      },
      expression: "editForm.dealerSpecialDiscount"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "TDS Amount"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Enter TDS Amount",
      clearable: ""
    },
    model: {
      value: _vm.editForm.tdsAmount,
      callback: function ($$v) {
        _vm.$set(_vm.editForm, "tdsAmount", $$v);
      },
      expression: "editForm.tdsAmount"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "TCS Amount"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Enter TCS Amount",
      clearable: ""
    },
    model: {
      value: _vm.editForm.tcsAmount,
      callback: function ($$v) {
        _vm.$set(_vm.editForm, "tcsAmount", $$v);
      },
      expression: "editForm.tcsAmount"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Recalculate Type"
    }
  }, [_c("el-switch", {
    attrs: {
      disabled: "",
      "active-text": "Soft",
      "inactive-text": "Hard"
    },
    model: {
      value: _vm.editForm.softRecalculate,
      callback: function ($$v) {
        _vm.$set(_vm.editForm, "softRecalculate", $$v);
      },
      expression: "editForm.softRecalculate"
    }
  })], 1)], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: _vm.handleEditCancel
    }
  }, [_vm._v("Cancel")]), _c("el-button", {
    attrs: {
      type: "primary",
      loading: _vm.editSaving
    },
    on: {
      click: _vm.handleEditSave
    }
  }, [_vm._v("Save")])], 1)], 1), _vm.isBranchDispatch && _vm.isStatusInTransit ? _c("div", [_c("el-tag", {
    attrs: {
      type: "danger"
    }
  }, [_vm._v(" " + _vm._s(`${this.sourceBranchName}(${this.sourceUnitName})`) + " ")]), _vm._v(" ----> "), _c("el-tag", {
    attrs: {
      type: "success"
    }
  }, [_vm._v(" " + _vm._s(`${this.destinationBranchName}(${this.destinationUnitName})`) + " ")])], 1) : _vm._e(), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.listLoading,
      expression: "listLoading"
    }],
    key: _vm.tableKey,
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.list,
      border: "",
      fit: "",
      "empty-text": "No data"
    }
  }, [_c("el-table-column", {
    attrs: {
      sortable: "custom",
      width: "80",
      align: "center",
      label: _vm.$t("table.id"),
      prop: "id"
    }
  }), _c("el-table-column", {
    attrs: {
      width: "160",
      align: "center",
      prop: "orderId",
      label: "Order"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("router-link", {
          attrs: {
            to: "/order/" + scope.row.orderId,
            type: "primary"
          }
        }, [_c("el-link", {
          attrs: {
            type: "primary"
          }
        }, [_vm._v(" " + _vm._s(scope.row.order.orderReference) + " ")])], 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "280",
      prop: "ordersProductId",
      label: "Product"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.ordersProduct.product.name) + " "), _c("br"), scope.row.ordersProduct.productsVariation ? _c("small", [_vm._v(" (" + _vm._s(scope.row.ordersProduct.productsVariation.name) + ") ")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: [_vm.SUPER_ADMIN],
      expression: "[SUPER_ADMIN]"
    }],
    attrs: {
      width: "120px",
      align: "center",
      prop: "totalCartonCount",
      label: "Carton Ordered"
    }
  }), _c("el-table-column", {
    attrs: {
      width: "140px",
      align: "center",
      prop: "ordersProduct.quantity",
      label: "Qty Ordered"
    }
  }), _c("el-table-column", {
    attrs: {
      width: "160",
      align: "center",
      prop: "quantity",
      label: "Qty Dispatched"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-input-number", {
          attrs: {
            size: "mini",
            min: scope.row.ordersProduct.product.piecesPerBox,
            max: scope.row.maxQuantity,
            step: scope.row.ordersProduct.product.piecesPerBox,
            "step-strictly": "",
            disabled: scope.row.isDisabled
          },
          on: {
            change: function ($event) {
              return _vm.handleDispatchQuantityChange(scope.row, $event);
            },
            blur: function ($event) {
              return _vm.handleDispatchQuantityChange(scope.row, scope.row.quantity);
            }
          },
          model: {
            value: scope.row.quantity,
            callback: function ($$v) {
              _vm.$set(scope.row, "quantity", $$v);
            },
            expression: "scope.row.quantity"
          }
        }), _vm.loggedInAdmin.roles.includes("Unit Manager") && _vm.dispatchInfo && _vm.dispatchInfo.status === "Pending" && scope.row.isDisabled ? _c("el-button", {
          attrs: {
            size: "mini",
            type: "primary",
            plain: ""
          },
          on: {
            click: function ($event) {
              return _vm.toggleDisable(scope.$index, scope.row);
            }
          }
        }, [_c("i", {
          staticClass: "el-icon-edit"
        })]) : _vm._e(), !scope.row.isDisabled ? _c("el-button", {
          attrs: {
            size: "mini",
            type: "danger",
            plain: ""
          },
          on: {
            click: function ($event) {
              return _vm.cancelDispatchQuantityChange(scope.row);
            }
          }
        }, [_c("i", {
          staticClass: "el-icon-close"
        })]) : _vm._e(), !scope.row.isDisabled ? _c("el-popconfirm", {
          attrs: {
            title: "Are you sure to update the quantity?"
          },
          on: {
            confirm: function ($event) {
              return _vm.saveDispatchQuantityChange(scope.row, scope.$index);
            },
            cancel: function ($event) {
              return _vm.cancelDispatchQuantityChange(scope.row);
            }
          }
        }, [_c("el-button", {
          attrs: {
            slot: "reference",
            size: "mini",
            type: "success",
            plain: ""
          },
          slot: "reference"
        }, [_c("i", {
          staticClass: "el-icon-check"
        })])], 1) : _vm._e()];
      }
    }])
  }), _vm.isBranchDispatch && _vm.isStatusInTransit ? _c("el-table-column", {
    attrs: {
      width: "140px",
      align: "center",
      label: "Qty Received",
      prop: "quantityReceived"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-input-number", {
          attrs: {
            size: "mini",
            min: 0,
            step: 1,
            disabled: _vm.loggedInAdminId === _vm.dispatchInfo.adminId
          },
          on: {
            change: function ($event) {
              return _vm.handleQuantityReceived(scope.row, $event);
            }
          },
          model: {
            value: scope.row.quantityReceived,
            callback: function ($$v) {
              _vm.$set(scope.row, "quantityReceived", $$v);
            },
            expression: "scope.row.quantityReceived"
          }
        })];
      }
    }], null, false, 2288456439)
  }) : _vm._e(), _vm.isBranchDispatch && _vm.isStatusInTransit ? _c("el-table-column", {
    attrs: {
      label: "Comments",
      width: "280",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-input", {
          attrs: {
            type: "textarea",
            autosize: {
              minRows: 3,
              maxRows: 4
            },
            placeholder: "Comments",
            disabled: _vm.loggedInAdminId === _vm.dispatchInfo.adminId
          },
          on: {
            input: function ($event) {
              return _vm.handleCommentsInput(scope.row, $event);
            }
          },
          model: {
            value: scope.row.comments,
            callback: function ($$v) {
              _vm.$set(scope.row, "comments", $$v);
            },
            expression: "scope.row.comments"
          }
        })];
      }
    }], null, false, 3117184776)
  }) : _vm._e(), _vm.isBranchDispatch && _vm.isStatusInTransit ? _c("el-table-column", {
    attrs: {
      width: "160",
      align: "center",
      label: "Wrong Product"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-switch", {
          attrs: {
            "active-text": "Yes",
            "inactive-text": "No",
            disabled: _vm.loggedInAdminId === _vm.dispatchInfo.adminId
          },
          model: {
            value: scope.row.isWrongProduct,
            callback: function ($$v) {
              _vm.$set(scope.row, "isWrongProduct", $$v);
            },
            expression: "scope.row.isWrongProduct"
          }
        }), scope.row.isWrongProduct ? _c("el-button", {
          staticStyle: {
            "margin-top": "10px"
          },
          attrs: {
            size: "mini",
            type: "primary",
            plain: ""
          },
          on: {
            click: function ($event) {
              return _vm.toggleWrongProductDialogVisible(scope.$index, scope.row);
            }
          }
        }, [_vm._v(" Select Wrong Product ")]) : _vm._e()];
      }
    }], null, false, 2927350107)
  }) : _vm._e(), _vm.isBranchDispatch && _vm.isStatusInTransit && _vm.hasAnyWrongProduct ? _c("el-table-column", {
    attrs: {
      width: "200",
      align: "center",
      label: "Products Received"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [scope.row.productsReceived && scope.row.productsReceived.length > 0 ? _c("div", _vm._l(scope.row.productsReceived, function (product, index) {
          return _c("el-tag", {
            key: index,
            staticStyle: {
              margin: "2px"
            },
            attrs: {
              size: "mini"
            }
          }, [_vm._v(" " + _vm._s(product.productName) + _vm._s(product.variationName ? "-" + product.variationName : "") + " - " + _vm._s(product.quantity) + " ")]);
        }), 1) : _c("span", [_vm._v("-")])];
      }
    }], null, false, 2104195839)
  }) : _vm._e(), _c("el-table-column", {
    attrs: {
      label: _vm.$t("table.createdDate"),
      width: "180",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(_vm._f("moment")(scope.row.createdTimestamp, "DD-MM-YYYY hh:mm a")) + " ")];
      }
    }])
  })], 1), _c("el-dialog", {
    attrs: {
      title: "Select Products Received",
      visible: _vm.wrongProductDialogVisible,
      width: "70%"
    },
    on: {
      "update:visible": function ($event) {
        _vm.wrongProductDialogVisible = $event;
      }
    }
  }, [_c("div", {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c("el-button", {
    attrs: {
      type: "primary",
      size: "mini",
      icon: "el-icon-plus"
    },
    on: {
      click: _vm.addProductRow
    }
  }, [_vm._v(" Add Product ")])], 1), _c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.wrongProductTableData,
      border: "",
      "empty-text": "No products added"
    }
  }, [_c("el-table-column", {
    attrs: {
      width: "400",
      label: "Product"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-select", {
          staticClass: "filter-item",
          staticStyle: {
            width: "100%"
          },
          attrs: {
            filterable: "",
            remote: "",
            clearable: "",
            "remote-method": _vm.getProductList,
            loading: _vm.productListLoading,
            placeholder: "Type to search products..."
          },
          on: {
            change: function ($event) {
              return _vm.handleProductChange(scope.$index, $event);
            }
          },
          model: {
            value: scope.row.selectedProduct,
            callback: function ($$v) {
              _vm.$set(scope.row, "selectedProduct", $$v);
            },
            expression: "scope.row.selectedProduct"
          }
        }, _vm._l(_vm.products, function (product) {
          return _c("el-option-group", {
            key: product.id,
            attrs: {
              label: product.name
            }
          }, [_c("el-option", {
            key: "product-" + product.id,
            attrs: {
              disabled: product.productType !== "simple",
              label: product.name,
              value: product.id + "-product-" + product.name
            }
          }, [_c("span", {
            staticStyle: {
              "font-weight": "bold"
            }
          }, [_vm._v(_vm._s(product.name))])]), product.productType !== "simple" && product.productsVariation && product.productsVariation.length ? [_c("el-option", {
            key: "variations-label-" + product.id,
            attrs: {
              label: "Variations",
              disabled: ""
            }
          }, [_c("span", {
            staticStyle: {
              "font-style": "italic",
              color: "gray"
            }
          }, [_vm._v("Variations:")])]), _vm._l(product.productsVariation, function (item) {
            return _c("el-option", {
              key: item.id,
              attrs: {
                label: product.name + "-" + item.name,
                value: product.id + "-variation-" + item.id + "-" + product.name + "-" + item.name
              }
            }, [_c("span", [_vm._v(_vm._s(item.name))])]);
          })] : _vm._e()], 2);
        }), 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "150",
      label: "Quantity"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-input-number", {
          staticStyle: {
            width: "100%"
          },
          attrs: {
            size: "mini",
            min: 1,
            step: 1
          },
          model: {
            value: scope.row.quantity,
            callback: function ($$v) {
              _vm.$set(scope.row, "quantity", $$v);
            },
            expression: "scope.row.quantity"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "100",
      label: "Actions",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-button", {
          attrs: {
            type: "danger",
            size: "mini",
            icon: "el-icon-delete"
          },
          on: {
            click: function ($event) {
              return _vm.removeProductRow(scope.$index);
            }
          }
        })];
      }
    }])
  })], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: function ($event) {
        _vm.wrongProductDialogVisible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.saveWrongProducts
    }
  }, [_vm._v("Confirm")])], 1)], 1), _c("br"), _c("div", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm.showRequestApprovalButton && !_vm.isReadOnlyUser ? _c("el-popconfirm", {
    attrs: {
      title: "Are you sure?"
    },
    on: {
      confirm: function ($event) {
        return _vm.sendForApproval(_vm.ordersDispatchId);
      }
    }
  }, [_c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loadingForRequestApproval,
      expression: "loadingForRequestApproval"
    }],
    attrs: {
      slot: "reference",
      size: "mini",
      icon: "el-icon-success",
      type: "success"
    },
    slot: "reference"
  }, [_vm._v(" Send for Approval ")])], 1) : _vm._e(), _vm._v("   "), _vm.showPreviewButton ? _c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loadingForPreview,
      expression: "loadingForPreview"
    }],
    attrs: {
      size: "mini",
      icon: "el-icon-document",
      type: "warning"
    },
    on: {
      click: function ($event) {
        return _vm.downloadInvoice(_vm.ordersDispatchId);
      }
    }
  }, [_vm._v(" Preview Invoice ")]) : _vm._e(), _vm._v("   "), _vm.showApproveButton && !_vm.isReadOnlyUser ? _c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loadingForApprove,
      expression: "loadingForApprove"
    }],
    attrs: {
      size: "mini",
      icon: "el-icon-success",
      type: "success"
    },
    on: {
      click: function ($event) {
        _vm.approveDialogFormVisible = true;
      }
    }
  }, [_vm._v(" Approve ")]) : _vm._e(), _vm.isBranchDispatch && _vm.isStatusInTransit && !_vm.isTransitApprovedAlready && _vm.loggedInAdminId !== _vm.dispatchInfo.adminId && (_vm$loggedInAdmin$rol = _vm.loggedInAdmin.roles) !== null && _vm$loggedInAdmin$rol !== void 0 && _vm$loggedInAdmin$rol.includes("Unit Manager") && !_vm.isReadOnlyUser ? _c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loadingForApprove,
      expression: "loadingForApprove"
    }],
    attrs: {
      size: "mini",
      icon: "el-icon-success",
      type: "primary"
    },
    on: {
      click: _vm.handleApproveTransit
    }
  }, [_vm._v(" Approve Transit ")]) : _vm._e(), _vm.isBranchDispatch && !_vm.isStatusInTransit && _vm.isDispatchApproved && !_vm.isTransitApprovedAlready && !_vm.isReadOnlyUser && (_vm.loggedInAdminId === _vm.dispatchInfo.adminId || _vm._isSuperAdmin() || _vm._isInvoiceManager()) ? _c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loadingForApprove,
      expression: "loadingForApprove"
    }],
    attrs: {
      size: "mini",
      icon: "el-icon-success",
      type: "primary"
    },
    on: {
      click: _vm.handleTransit
    }
  }, [_vm._v(" In Transit ")]) : _vm._e(), _vm._v("   "), _vm.showRejectButton && !_vm.isReadOnlyUser ? _c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loadingForReject,
      expression: "loadingForReject"
    }],
    attrs: {
      size: "mini",
      icon: "el-icon-error",
      type: "danger"
    },
    on: {
      click: function ($event) {
        _vm.rejectDialogFormVisible = true;
      }
    }
  }, [_vm._v(" Reject ")]) : _vm._e()], 1), _c("el-dialog", {
    attrs: {
      title: _vm.dialogTitle,
      visible: _vm.approveDialogFormVisible
    },
    on: {
      "update:visible": function ($event) {
        _vm.approveDialogFormVisible = $event;
      }
    }
  }, [_c("el-form", {
    ref: "formData",
    staticClass: "demo-form",
    attrs: {
      model: _vm.formData,
      rules: _vm.rules
    }
  }, [_c("el-form-item", {
    attrs: {
      prop: "termsOfDelivery"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      autocomplete: "off",
      rows: 5,
      placeholder: "Enter terms of delivery..."
    },
    model: {
      value: _vm.formData.termsOfDelivery,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "termsOfDelivery", $$v);
      },
      expression: "formData.termsOfDelivery"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "TD: ",
      prop: "tdsAmount"
    }
  }, [_vm._v(" " + _vm._s(_vm.formData.tdsAmount) + " ")])], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      size: "mini"
    },
    on: {
      click: function ($event) {
        _vm.approveDialogFormVisible = false;
      }
    }
  }, [_vm._v(" Cancel ")]), _c("el-button", {
    attrs: {
      size: "mini",
      type: "primary"
    },
    on: {
      click: function ($event) {
        return _vm.validateForm("Approve");
      }
    }
  }, [_vm._v(" Confirm ")])], 1)], 1), _c("el-dialog", {
    attrs: {
      title: "Reject Dispatch",
      visible: _vm.rejectDialogFormVisible
    },
    on: {
      "update:visible": function ($event) {
        _vm.rejectDialogFormVisible = $event;
      }
    }
  }, [_c("el-form", {
    ref: "formData",
    staticClass: "demo-form",
    attrs: {
      model: _vm.formData,
      rules: _vm.rules
    }
  }, [_c("el-form-item", {
    attrs: {
      prop: "rejectReason"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      autocomplete: "off",
      rows: 5,
      placeholder: "Enter reason for rejection..."
    },
    model: {
      value: _vm.formData.rejectReason,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "rejectReason", $$v);
      },
      expression: "formData.rejectReason"
    }
  })], 1)], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      size: "mini"
    },
    on: {
      click: function ($event) {
        _vm.rejectDialogFormVisible = false;
      }
    }
  }, [_vm._v(" Cancel ")]), _c("el-button", {
    attrs: {
      size: "mini",
      type: "primary"
    },
    on: {
      click: function ($event) {
        return _vm.validateForm("Reject");
      }
    }
  }, [_vm._v(" Confirm ")])], 1)], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;